// src/service/Pago.js
import instance from "../apis/app";

const Pago = {
  /**
   * Iniciar pago con WebPay
   * POST /api/pagos/iniciar
   * @param {string} ordenId - ID de la orden de compra
   * @returns {Promise} - { pagoId, token, url }
   */
  IniciarPago: async (ordenId) => {
    try {
      const response = await instance.post('/pagos/iniciar', { ordenId });

      return response
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene pago por ID
   * GET /api/pagos/:id
   * @param {string} pagoId - ID del pago
   * @returns {Promise}
   */
  Get: async (pagoId) => {
    try {
      const response = await instance.get(`/pagos/${pagoId}`);
      return response;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene todos los pagos del usuario
   * GET /api/pagos/mis-pagos
   * @returns {Promise} - Array de pagos
   */
  MisPagos: async () => {
    try {
      const response = await instance.get('/pagos/mis-pagos');
      return response.data.data || [];
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene estadísticas de pagos del usuario
   * GET /api/pagos/mis-pagos/estadisticas
   * @returns {Promise}
   */
  ObtenerEstadisticas: async () => {
    try {
      const response = await instance.get('/pagos/mis-pagos/estadisticas');
      return response.data.data || {};
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
};

export default Pago;
